export default __webpack_public_path__ + "static/media/account_active.e0220dbf.svg";